import type { UserData } from './types';

export const flowStepSegments = ['contact', 'second', 'payment', 'summary', 'success'] as const;

export function isFlowPathname(pathname: string) {
  const segments = pathname.split('/').filter(Boolean);

  return segments.length === 2 && flowStepSegments.some((step) => step === segments[1]);
}

export const steps = (cid: string) => flowStepSegments.map((step) => `/${cid}/${step}`);

export const getPreviousStep = (cid: string, currentStep: number, data: UserData) => {
  const hasSecondTenant = !!data?.secondTenant;

  if (currentStep === 2 && !hasSecondTenant) {
    return steps(cid)[0]; // Skip step 1 if no second tenant
  }

  return currentStep > 0 ? steps(cid)[currentStep - 1] : null;
};

export const getNextStep = (cid: string, currentStep: number, data: UserData) => {
  const hasSecondTenant = !!data?.secondTenant;

  return currentStep >= 0 && currentStep < steps(cid).length - 2
    ? currentStep === 0 && hasSecondTenant === false
      ? steps(cid)[currentStep + 2]
      : steps(cid)[currentStep + 1]
    : null;
};

export const headerText = (pathname: string, cid: string, data: UserData | null) => {
  switch (pathname) {
    case steps(cid)[0]:
      return `Daten von ${data?.immutableData.firstTenant.name} vervollständigen`;
    case steps(cid)[1]:
      return `Daten von ${data?.immutableData.secondTenant?.name} vervollständigen`;
    case steps(cid)[2]:
      return 'Zahlungsweise und Bankverbindung festlegen';
    case steps(cid)[3]:
      return 'Zusammenfassung und Vertragsbedingungen';
    case steps(cid)[4]:
      return 'Vielen Dank für Ihre Anfrage!';
    default:
      return 'Unknown step';
  }
};

export const descriptionText = (pathname: string, cid: string) => {
  switch (pathname) {
    case steps(cid)[0]:
      return 'Bitte überprüfen Sie die folgenden Daten. Falls Sie Änderungen vornehmen möchten, können Sie dies direkt hier im Antrag erledigen.';
    case steps(cid)[1]:
      return 'Bitte überprüfen Sie die folgenden Daten. Falls Sie Änderungen vornehmen möchten, können Sie dies direkt hier im Antrag erledigen.';
    case steps(cid)[2]:
      return 'Bitte wählen Sie Ihre bevorzugte Zahlungsweise aus und überprüfen Sie Ihre Bankverbindung. Änderungen können Sie direkt hier vornehmen, um den Zahlungsprozess reibungslos abzuschließen.';
    case steps(cid)[3]:
      return 'Hier finden Sie eine Übersicht Ihrer Angaben sowie die Vertragsbedingungen. Bitte überprüfen Sie alle Informationen sorgfältig. Lesen Sie die Vertragsbedingungen durch, bevor Sie fortfahren.';
    case steps(cid)[4]:
      return `Hier finden Sie weitere Informationen zu Ihrer Kautionsbürgschaft.`;
    default:
      return 'Unknown step';
  }
};
